export default class SocialLinkOverlay {
    static SOCIAL_LINK_OPEN_CLASS = 'social-overlay--open'
    static SOCIAL_LINK_BOX = 'link-box'
    static SOCIAL_LINK_ICON_SELECTOR = '.js-social-link'

    constructor() {
        this.socialLinks = document.querySelectorAll(SocialLinkOverlay.SOCIAL_LINK_ICON_SELECTOR)
        this.initEventListener()
    }

    initEventListener() {
        document.addEventListener('click', () => {
            this.closeAll()
        })

        this.socialLinks.forEach((socialLink) => {
            socialLink.addEventListener('click', (event) => {
                if (socialLink.classList.contains(SocialLinkOverlay.SOCIAL_LINK_OPEN_CLASS)) {
                    this.closeAll(socialLink)
                } else {
                    event.stopPropagation()
                    this.closeAll()
                    this.open(socialLink)
                }
            })
        })
    }

    open(socialLink) {
        socialLink.classList.add(SocialLinkOverlay.SOCIAL_LINK_OPEN_CLASS)
    }

    closeAll() {
        this.socialLinks.forEach((socialLink) => {
            socialLink.classList.remove(SocialLinkOverlay.SOCIAL_LINK_OPEN_CLASS)
        })
    }
}
